export { default as CoreBootEmptyModule } from './module';
